var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKugelMittlereLagen(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 657 390",
    style: {
      enableBackground: "new 0 0 657 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFA3B0;}\n\t.st1{fill:#AD427F;}\n\t.st2{opacity:0.62;}\n\t.st3{fill:#E0F2FD;}\n\t.st4{fill:#CEDCDD;}\n\t.st5{opacity:0.58;fill:#D2DFE6;enable-background:new    ;}\n\t.st6{opacity:0.81;}\n\t.st7{fill:#A5BFCD;}\n\t.st8{fill:#D2DFE6;}\n\t.st9{opacity:0.55;fill:#D2DFE6;enable-background:new    ;}\n\t.st10{opacity:0.55;fill:#B5C1BC;enable-background:new    ;}\n\t.st11{opacity:0.61;fill:#456558;enable-background:new    ;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#EAEAEA;}\n\t.st14{fill:#B4456F;}\n\t.st15{fill:#244658;}\n\t.st16{fill:#C4C3B9;}\n\t.st17{fill:#6A8479;}\n\t.st18{fill:#456558;}\n\t.st19{fill:none;stroke:#745336;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#745336;stroke-width:0.9903;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boden"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,338.3h633c6.6,0,12,5.4,12,12v7c0,6.6-5.4,12-12,12H12c-6.6,0-12-5.4-12-12v-7 C0,343.7,5.4,338.3,12,338.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.6,369.2h483.8c4.7,0,8.6,3.8,8.6,8.6v3.6c0,4.7-3.8,8.6-8.6,8.6H86.6c-4.7,0-8.6-3.8-8.6-8.6v-3.6 C78,373,81.8,369.2,86.6,369.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "glas"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.5,358c-190.2,0-328.2-4.6-328.2-11c0-92.6,34.1-179.7,96.1-245.2c62-65.5,144.4-101.6,232-101.6 s170.1,36.1,232,101.6c62,65.5,96.1,152.6,96.1,245.2C656.7,353.4,518.7,358,328.5,358z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.5,0.5c44.3,0,87.2,9.2,127.6,27.2c39,17.5,74.1,42.4,104.2,74.3c30.1,31.8,53.8,68.9,70.3,110.2 c17.1,42.7,25.8,88.1,25.8,134.9c0,0-0.1,1-7,2.1c-4.7,0.8-11.7,1.6-20.8,2.3c-17.3,1.4-42.4,2.5-74.4,3.5 c-59.6,1.8-139.7,2.8-225.8,2.8s-166.2-1-225.8-2.8c-32-1-57.1-2.2-74.4-3.5c-9.1-0.7-16.1-1.5-20.8-2.3c-6.9-1.2-7-2.1-7-2.1 c0-46.8,8.7-92.2,25.8-134.9c16.5-41.3,40.2-78.3,70.3-110.2c30.1-31.8,65.2-56.8,104.2-74.3C241.3,9.7,284.2,0.5,328.5,0.5  M328.5,0C147.1,0,0.1,155.4,0.1,347c0,7.5,164.2,11.2,328.4,11.2s328.4-3.7,328.4-11.2C656.9,155.4,509.9,0,328.5,0L328.5,0z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "landschaft"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577.4,258.5 509.5,338.3 577.4,338.3 645.2,338.3  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "506.4,226.9 596.1,338.3 506.4,338.3 506.4,226.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "506.4,226.9 416.7,338.3 506.4,338.3 506.4,226.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "155.4,226.9 245.1,338.3 155.4,338.3 155.4,226.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "155.4,226.9 65.7,338.3 155.4,338.3 155.4,226.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "98.1,243.9 30.2,338.3 98.1,338.3 165.9,338.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M265.3,338.3c0,0,66.5-148.5,146.5,0H265.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M397.3,338.3c0,0,66.5-97.8,146.6,0H397.3L397.3,338.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M11.8,338.3c0,0,64.3-143.2,141.7,0H11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M166.4,338.3c0,0,51-94.8,112.4,0H166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M481,338.3c0,0,59.4-127.2,131,0H481z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "261.1,143.3 410.2,338.3 261.1,338.3 261.1,143.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "261.1,143.3 111.9,338.3 261.1,338.3 261.1,143.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "235.1,177.3 251.1,180.3 261.1,190.3 261.1,190.3 285.1,187.3 297.1,190.3 261.1,143.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "261.1,143.3 261.1,190.3 285.1,187.3 297.1,190.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "390.5,162.3 525.1,338.3 390.5,338.3 390.5,162.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "390.5,162.3 255.9,338.3 390.5,338.3 390.5,162.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "367.1,193 381.5,195.7 390.5,204.8 390.5,204.8 412.2,202 423,204.8 390.5,162.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "390.5,162.3 390.5,204.8 412.2,202 423,204.8  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M81.8,338.3c0,0,51-94.8,112.4,0H81.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.5,
    y: 283.1,
    className: "st14",
    width: 90.3,
    height: 55.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 286.5,
    className: "st0",
    width: 6.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.1,
    y: 290.8,
    className: "st0",
    width: 6.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M332.9,280c1.6,1.7,1,3.1-1.4,3.1H228.2c-2.3,0-3-1.4-1.4-3.1l50.1-54.3c1.6-1.7,4.2-1.7,5.8,0L332.9,280z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "327,283.1 231.8,283.1 279.4,231.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 279.7,
    cy: 266.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 279.7,
    cy: 266.5,
    r: 5.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 333.9,
    className: "st16",
    width: 25.7,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.8,
    y: 300.9,
    className: "st0",
    width: 25.2,
    height: 20.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.4,
    y: 300.9,
    className: "st0",
    width: 25.2,
    height: 20.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 297.9,
    y: 311.8,
    className: "st15",
    width: 10.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.8,
    y: 311.8,
    className: "st15",
    width: 10.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.9,
    y: 302.7,
    className: "st15",
    width: 10.1,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.8,
    y: 302.7,
    className: "st15",
    width: 10.1,
    height: 7.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 263.4,
    y: 311.8,
    className: "st15",
    width: 10.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.3,
    y: 311.8,
    className: "st15",
    width: 10.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.4,
    y: 302.7,
    className: "st15",
    width: 10.1,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.3,
    y: 302.7,
    className: "st15",
    width: 10.1,
    height: 7.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.2,
    y: 260.6,
    className: "st16",
    width: 66.2,
    height: 77.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M484,258.2c0,1.4-1.4,2.5-3,2.5h-64.9c-1.7,0-3-1.1-3-2.5s1.4-2.5,3-2.5h64.9 C482.6,255.7,484,256.8,484,258.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.2,
    y: 334.7,
    className: "st15",
    width: 28.2,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421.7,
    y: 267.9,
    className: "st12",
    width: 22.4,
    height: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 433.8,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.8,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.8,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.1,
    y: 267.9,
    className: "st12",
    width: 22.4,
    height: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.2,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.4,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.2,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.4,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.2,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 453.4,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 452.1,
    y: 303.6,
    className: "st0",
    width: 22.4,
    height: 31.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M464.1,314.1h7.6c0,0,0-7.2-7.6-8.4V314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M462.6,314.1h-7.6c0,0,0-7.2,7.6-8.4V314.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 470.2,
    cy: 322.8,
    r: 1.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 240.3,
    className: "st16",
    width: 10.5,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.9,
    y: 242.6,
    className: "st14",
    width: 6.1,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.4,
    y: 245.5,
    className: "st14",
    width: 4.3,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421.8,
    y: 303.6,
    className: "st12",
    width: 22.4,
    height: 18.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 433.9,
    y: 313.3,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 313.3,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.9,
    y: 305.3,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 305.3,
    className: "st15",
    width: 9,
    height: 6.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 149.2,
    y: 260.6,
    className: "st16",
    width: 66.2,
    height: 77.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218,258.2c0,1.4-1.4,2.5-3,2.5h-64.9c-1.7,0-3-1.1-3-2.5s1.4-2.5,3-2.5h64.9 C216.6,255.7,218,256.8,218,258.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.2,
    y: 334.7,
    className: "st15",
    width: 28.2,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.7,
    y: 267.9,
    className: "st12",
    width: 22.4,
    height: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.8,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.8,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.8,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 186.1,
    y: 267.9,
    className: "st12",
    width: 22.4,
    height: 27.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.2,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 286.1,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.2,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 278,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.2,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.4,
    y: 270.1,
    className: "st15",
    width: 9,
    height: 6.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 186.1,
    y: 303.6,
    className: "st0",
    width: 22.4,
    height: 31.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M198.1,314.1h7.6c0,0,0-7.2-7.6-8.4V314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M196.6,314.1h-7.6c0,0,0-7.2,7.6-8.4V314.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 204.2,
    cy: 322.8,
    r: 1.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 240.3,
    className: "st16",
    width: 10.5,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.9,
    y: 242.6,
    className: "st14",
    width: 6.1,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 245.5,
    className: "st14",
    width: 4.3,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 303.6,
    className: "st12",
    width: 22.4,
    height: 18.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.9,
    y: 313.3,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.1,
    y: 313.3,
    className: "st15",
    width: 9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.9,
    y: 305.3,
    className: "st15",
    width: 9,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.1,
    y: 305.3,
    className: "st15",
    width: 9,
    height: 6.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.3,
    y: 292.3,
    className: "st12",
    width: 77.8,
    height: 46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "375.6,291.5 336.7,291.5 336.7,268.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "375.8,269.3 375.8,239.1 336.9,239.1 336.9,269.3 317.1,292.3 317.1,338.3 394.9,338.3  394.9,292.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "356,167.6 336.9,239.1 375.8,239.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "324.2,328 335.5,328 335.5,306.7 329.7,297.1 324.2,306.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "375.8,328 387.1,328 387.1,306.7 381.3,297.1 375.8,306.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "345.7,338.3 367.1,338.3 367.1,297.8 356,279.6 345.7,297.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "356.1,284.2 349.2,296.4 363.5,296.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "381.3,300.3 377.5,307 385.4,307  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "329.7,299.8 325.9,306.6 333.8,306.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 334.5,
    className: "st16",
    width: 23.8,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M478.6,307.1C478.6,296,499,287,499,287v40.2C499,327.2,478.6,318.2,478.6,307.1L478.6,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M519.1,307.1C519.1,296,499,287,499,287v40.2C499,327.2,519.1,318.2,519.1,307.1L519.1,307.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 502.2,
    y1: 301.3,
    x2: 499,
    y2: 306.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 493.8,
    y1: 309.7,
    x2: 499,
    y2: 316.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "499,287.9 499,302.4 499,305.8 499,338.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M491.4,291.1c3.2-2.1,6.6-3.9,7.7-4.2v5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M506.6,291.2c-2.1-1.4-6.5-3.9-7.6-4.2v5.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M72.3,307.1c0-11.1,20.4-20.1,20.4-20.1v40.2C92.7,327.2,72.3,318.2,72.3,307.1L72.3,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M112.8,307.1c0-11.1-20.1-20.1-20.1-20.1v40.2C92.7,327.2,112.8,318.2,112.8,307.1L112.8,307.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 95.9,
    y1: 301.3,
    x2: 92.7,
    y2: 306.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 87.5,
    y1: 309.7,
    x2: 92.7,
    y2: 316.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "92.7,287.9 92.7,302.4 92.7,305.8 92.7,338.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.1,291.1c3.2-2.1,6.6-3.9,7.7-4.2v5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.3,291.2c-2.1-1.4-6.5-3.9-7.6-4.2v5.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M543.8,306.9c0-11.1,20.4-20.1,20.4-20.1V327C564.3,327,543.8,318,543.8,306.9L543.8,306.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M584.4,306.9c0-11.1-20.1-20.1-20.1-20.1V327C564.3,327,584.4,318,584.4,306.9L584.4,306.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 567.4,
    y1: 301.2,
    x2: 564.3,
    y2: 306.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 559,
    y1: 309.6,
    x2: 564.3,
    y2: 316.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "564.3,287.8 564.3,302.3 564.3,305.7 564.3,338.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M556.6,291c3.2-2.1,6.6-3.9,7.7-4.2v5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M571.9,291c-2.1-1.4-6.5-3.9-7.6-4.2v5.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M568.1,306.3c0-11.1,20.4-20.1,20.4-20.1v40.2C588.5,326.4,568.1,317.4,568.1,306.3L568.1,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M608.6,306.3c0-11.1-20.1-20.1-20.1-20.1v40.2C588.5,326.4,608.6,317.4,608.6,306.3L608.6,306.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 591.7,
    y1: 300.5,
    x2: 588.5,
    y2: 305.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 583.3,
    y1: 308.9,
    x2: 588.5,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "588.5,287.2 588.5,301.6 588.5,305 588.5,337.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M580.9,290.4c3.2-2.1,6.6-3.9,7.7-4.2v5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M596.1,290.4c-2.1-1.4-6.5-3.9-7.6-4.2v5.2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKugelMittlereLagen);
export default __webpack_public_path__ + "static/media/kugel-mittlere-lagen.28824dee44382368908f86722163848e.svg";
export { ForwardRef as ReactComponent };